import keyboard from '@/helpers/keyboard'

export const Debug = {
  /** Render current image name */
  RENDER_CURRENT_IMAGE_NAME: false,
  /** Renders current image rect */
  RENDER_CURRENT_IMAGE_RECT: true,
  /** Renders bone volume */
  RENDER_BONE_VOLUME: true
}

export function init () {
  keyboard.start()
  keyboard.on('KeyD', () => {
    Debug.RENDER_CURRENT_IMAGE_RECT = !Debug.RENDER_CURRENT_IMAGE_RECT
    Debug.RENDER_BONE_VOLUME = !Debug.RENDER_BONE_VOLUME
  })
}

export function destroy () {
  keyboard.off('KeyD')
  keyboard.stop()
}

export default {
  Debug,
  init,
  destroy
}
